export default {
    name: 'mvtPagination',
    props: {
        activePageNumber: {
            type: Number,
            required: false,
            default: null,
        },
        countLabel: {
            type: String,
            required: false,
            default: 'Results',
        },
        groupPages: {
            type: Boolean,
            required: false,
            default: false,
        },
        groupSize: {
            type: Number,
            required: false,
            default: 25,
        },
        hideFirstPageLink: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideLastPageLink: {
            type: Boolean,
            required: false,
            default: false,
        },
        pageCount: {
            type: Number,
            required: true,
            default: null,
        },
        pageDisplayLimit: {
            type: Number,
            required: false,
            default: null,
        },
        pageSize: {
            type: Number,
            required: false,
            default: 0,
        },
        baseUrl: {
            type: String,
            required: false,
            default: '',
        },
        showCount: {
            type: Boolean,
            required: false,
            default: true,
        },
        totalCount: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    computed: {
        getBaseUrl() {
            return this.baseUrl;
        },
        prevLink() {
            if (this.activePageNumber > 2) {
                return `${this.baseUrl}p-${this.activePageNumber - 1}/` || null;
            } else if (this.activePageNumber === 2) {
                return `${this.baseUrl}` || null;
            } else {
                return null;
            }
        },
        nextLink() {
            if (this.activePageNumber < this.pageCount) {
                return `${this.baseUrl}p-${this.activePageNumber + 1}/` || null;
            } else {
                return null;
            }
        },
        firstLink() {
            return `${this.baseUrl}` || null;
        },
        lastLink() {
            return `${this.baseUrl}p-${this.pageCount}/` || null;
        },
        showFirstPage() {
            const isFirstPageAlreadyDisplayed = this.dynamicList.find((item) => item.pageNumber === 1);
            return !this.hideFirstPageLink && !isFirstPageAlreadyDisplayed;
        },
        showLastPage() {
            const isLastPageAlreadyDisplayed = this.dynamicList.find((item) => item.pageNumber === this.pageCount);
            return !this.hideLastPageLink && !isLastPageAlreadyDisplayed;
        },
        pages() {
            if (this.pageCount && this.pageCount > 0) {
                const pages = Array.from(Array(this.pageCount).keys());
                return pages.map((item, i) => {
                    return {
                        pageNumber: i + 1,
                        isGroup: false,
                    };
                });
            }
            return [];
        },
        dynamicList() {
            const chunks = [];
            let isActiveLast = false;
            let activeChunkIndex = 0;

            if (this.pages.length > 0) {
                const chunkSize = this.groupPages ? this.groupSize : this.pageDisplayLimit;

                if (chunkSize && chunkSize > 0) {
                    // Break all elements into arrays of chunkSize length
                    for (let i = 0; i < this.pages.length; i += chunkSize) {
                        const chunk = this.pages.slice(i, i + chunkSize);
                        chunks.push(chunk);
                        const currentLocation = chunk.findIndex((pageItem) => pageItem.pageNumber === this.activePageNumber);
                        if (currentLocation > -1) {
                            activeChunkIndex = chunks.length - 1;
                            if (currentLocation === chunk.length - 1) {
                                isActiveLast = true;
                            }
                        }
                    }

                    // If the item is the last item in its chunk, attach it to the next one
                    const showItems =
                        isActiveLast && !(activeChunkIndex === chunks.length - 1)
                            ? chunks[activeChunkIndex].slice(-1).concat(chunks[activeChunkIndex + 1].splice(0, chunks[activeChunkIndex + 1].length - 1))
                            : chunks[activeChunkIndex];

                    // Get the remaining groups of chunks and group them by chunk size
                    const groupItems = chunks.slice(activeChunkIndex + 1, chunks.length);

                    const groups = Array.from(Array(groupItems.length).keys())
                        .map((i) => {
                            const pageNumber = (i + 1) * this.groupSize + showItems[0].pageNumber;
                            const roundToNearestMultiple = pageNumber - (pageNumber % this.groupSize);
                            return {
                                pageNumber: roundToNearestMultiple,
                                isGroup: true,
                            };
                        })
                        .filter((groupItem) => {
                            return (
                                !showItems.find((shownItem) => shownItem.pageNumber === groupItem.pageNumber || shownItem.pageNumber + 1 === groupItem.pageNumber) &&
                                groupItem.pageNumber < this.pages.length
                            );
                        });

                    return this.groupPages ? showItems.concat(groups) : showItems;
                }
            }

            return this.pages;
        },
        paginationDetails() {
            const start = (this.activePageNumber - 1) * this.pageSize + 1;
            const end = this.activePageNumber === this.pageCount ? this.totalCount : start - 1 + Math.min(this.totalCount, this.pageSize);
            return {
                start: start.toLocaleString('en-US'),
                end: end.toLocaleString('en-US'),
                totalCount: this.totalCount.toLocaleString('en-US'),
                label: this.countLabel,
            };
        },
    },
};
